"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatMessageResponseElementToJSON = exports.ChatMessageResponseElementFromJSONTyped = exports.ChatMessageResponseElementFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function ChatMessageResponseElementFromJSON(json) {
    return ChatMessageResponseElementFromJSONTyped(json, false);
}
exports.ChatMessageResponseElementFromJSON = ChatMessageResponseElementFromJSON;
function ChatMessageResponseElementFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'chatMessage': !runtime_1.exists(json, 'chatMessage') ? undefined : _1.ChatMessageFromJSON(json['chatMessage']),
        'isOwnMessage': !runtime_1.exists(json, 'isOwnMessage') ? undefined : json['isOwnMessage'],
    };
}
exports.ChatMessageResponseElementFromJSONTyped = ChatMessageResponseElementFromJSONTyped;
function ChatMessageResponseElementToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chatMessage': _1.ChatMessageToJSON(value.chatMessage),
        'isOwnMessage': value.isOwnMessage,
    };
}
exports.ChatMessageResponseElementToJSON = ChatMessageResponseElementToJSON;
